(function () {
  const MOBILE_BREAKPOINT = 999;
  const SCROLL_THRESHOLD = 200;
  const FADE_MS = 300;
  const FILTER_GAP = 12;
  const POSITION_RETRY_FRAMES = 40;

  let pastShowPoint = false;
  let footerVisible = false;
  let overlayOpen = false;
  let shown = null;
  let fadeTimer = null;

  // ランチャーは Channel Talk の shadow DOM 内にありテーマ CSS が届かないため、
  // 表示切替は SDK、フェードは shadow root 内の要素へ直接 opacity を当てる
  const launcher = () => {
    const host = document.getElementById('ch-plugin-entry')?.firstElementChild;
    return host?.shadowRoot?.querySelector('[class*="LauncherButtonWrapper"]') || null;
  };

  // SP は絞り込みアイコンと同じ条件（商品リスト上端が画面に入る）で出す。
  // 商品リストが無いページは 5%クーポンバナーと同じ 200px、PC は初期から表示
  function isPastShowPoint() {
    if (window.innerWidth > MOBILE_BREAKPOINT) return true;
    const list = document.querySelector('.boost-sd__product-list, .boost-sd__product-item');
    if (list) return list.getBoundingClientRect().top < window.innerHeight;
    return window.pageYOffset >= SCROLL_THRESHOLD;
  }

  // Channel Talk は iOS のセーフエリアを加味した位置に出るため、絞り込みアイコンを
  // CSS の固定値で置くと実機でズレる。実測位置の上に積んで追従させる。
  // 表示直後はまだ描画されておらず計測できないので、出るまでフレーム単位で待つ
  function positionFilterButton(retry = 0) {
    const filterButton = document.querySelector('.sp-filter-toggle-icon-button');
    if (!filterButton) return;
    const el = launcher();
    const rect = el && el.getBoundingClientRect();
    if (!rect || !rect.height) {
      if (shown && retry < POSITION_RETRY_FRAMES) {
        requestAnimationFrame(() => positionFilterButton(retry + 1));
      }
      return;
    }
    filterButton.style.bottom = `${Math.round(window.innerHeight - rect.top + FILTER_GAP)}px`;
  }

  function apply() {
    if (!window.ChannelIO) return;

    const want = pastShowPoint && !footerVisible && !overlayOpen;
    if (want === shown) return;
    const initial = shown === null;
    shown = want;
    clearTimeout(fadeTimer);

    const el = launcher();
    if (want) {
      window.ChannelIO('showChannelButton');
      if (el && !initial) {
        el.style.transition = `opacity ${FADE_MS}ms ease`;
        el.style.opacity = '0';
        requestAnimationFrame(() => {
          const target = launcher();
          if (target) target.style.opacity = '1';
        });
      }
    } else if (el && !initial) {
      el.style.transition = `opacity ${FADE_MS}ms ease`;
      el.style.opacity = '0';
      fadeTimer = setTimeout(() => window.ChannelIO('hideChannelButton'), FADE_MS);
    } else {
      window.ChannelIO('hideChannelButton');
    }
  }

  function isBoostDrawerOpen() {
    const drawer = document.getElementById('boost-sd_filter-tree-mobile');
    if (!drawer) return false;
    const style = getComputedStyle(drawer);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const panel = drawer.querySelector('.boost-sd__filter-tree-vertical--sticky');
    return !!panel && !panel.classList.contains('boost-sd__filter-tree-vertical--hidden');
  }

  function sync() {
    pastShowPoint = isPastShowPoint();
    overlayOpen = isBoostDrawerOpen() || !!document.querySelector('facets-drawer[open]');
    apply();
    positionFilterButton();
  }

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      sync();
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // iOS はツールバーの出入りでセーフエリアと表示領域が変わる
  window.visualViewport?.addEventListener('resize', onScroll, { passive: true });
  window.visualViewport?.addEventListener('scroll', onScroll, { passive: true });

  const footer = document.querySelector('.shopify-section--footer, footer, [role="contentinfo"]');
  if (footer) {
    new IntersectionObserver((entries) => {
      footerVisible = entries[entries.length - 1].isIntersecting;
      apply();
    }).observe(footer);
  }

  document.querySelectorAll('facets-drawer').forEach((el) => {
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open'] });
  });

  // Boost のドロワーは非同期描画のため出現を待つ
  const waitFor = (test, done, timeout = 30000) => {
    if (test()) return done();
    const started = Date.now();
    const timer = setInterval(() => {
      if (test()) {
        clearInterval(timer);
        done();
      } else if (Date.now() - started > timeout) {
        clearInterval(timer);
      }
    }, 100);
  };

  waitFor(() => document.getElementById('boost-sd_filter-tree-mobile'), () => {
    new MutationObserver(sync).observe(document.getElementById('boost-sd_filter-tree-mobile'), {
      attributes: true,
      attributeFilter: ['style', 'class'],
      subtree: true
    });
    sync();
  });

  waitFor(() => window.ChannelIO, sync);

  // 描画を止めている CSS は、ランチャーが実際に狙いの状態になってから外す。
  // 初回描画時は SDK への指示が反映されていないことがあるため、一致するまで送り直す
  const markInitialized = () => document.documentElement.classList.add('ct-initialized');
  waitFor(() => {
    const el = launcher();
    if (!window.ChannelIO || !el) return false;
    if (shown === null) sync();
    const hidden = getComputedStyle(el).display === 'none';
    if (hidden !== shown) return true;
    window.ChannelIO(shown ? 'showChannelButton' : 'hideChannelButton');
    return false;
  }, () => requestAnimationFrame(markInitialized), 8000);
  setTimeout(markInitialized, 8000);
})();
